export default function isIOS() {
  return !!navigator.userAgent.match(/iPhone/i);
}
